import { Injectable } from '@angular/core';

declare var window: any;

@Injectable({
  providedIn: 'root',
})
export class GoogleMapService {
  private static promise;
  // map: google.maps.Map;
  map;

  googleMapApiKey = 'AIzaSyCndqv9f5_EE2f07WT7azTRBjy_8zvf32g';

  loadGoogleMapScript() {
    if (!GoogleMapService.promise) {
      // load once
      GoogleMapService.promise = new Promise((resolve) => {
        window['__onGapiLoaded'] = (ev) => {
          resolve(window.gapi);
        };

        const node = document.createElement('script');

        node.src =
          'https://maps.googleapis.com/maps/api/js?key=' +
          this.googleMapApiKey +
          '&libraries=places&callback=__onGapiLoaded';

        node.type = 'text/javascript';

        document.getElementsByTagName('head')[0].appendChild(node);
      });
    }

    return GoogleMapService.promise;
  }
}
